import { useEffect } from 'react';

import { buildValidFlowPath } from 'src/viewLayer/helpers/pathHelpers';
import { isInvalidLearnLang } from 'src/viewLayer/helpers/validateLearnLang';
import type { RouteConfigRef } from 'src/viewLayer/components/Flow/types';
import type { Navigate } from 'src/types/navigate';

interface UseRedirectToValidFlowPathParams {
  isInvalidNodeNumber: boolean;
  routeConfigRef: RouteConfigRef;
  learnLang: string;
  navigate: Navigate;
};

// Redirect to a valid flow path if the learn lang is invalid or the node number exceeds the flow length
const useRedirectToValidFlowPath = ({
  isInvalidNodeNumber,
  routeConfigRef,
  learnLang,
  navigate
}: UseRedirectToValidFlowPathParams): void => {
  useEffect(() => {
    const routeConfigRefCopy = { ...routeConfigRef };
    if (isInvalidNodeNumber) routeConfigRefCopy.nodeNumber = 0;
    if (isInvalidLearnLang(learnLang) || isInvalidNodeNumber) {
      navigate(buildValidFlowPath(routeConfigRefCopy));
    }
  }, [learnLang, isInvalidNodeNumber, navigate, routeConfigRef]);
};

export default useRedirectToValidFlowPath;
